import React, { use } from 'react'
import AdminLayout from '../../../layouts/AdminLayout'
import { Navigate, useNavigate } from 'react-router-dom'
import { adminPaths } from '../../../routes/admin'
const Payment = () => {
  const navigate = useNavigate();

  return (
    <div>
      <AdminLayout>
        <div className="ct_px_40 my-5">
          <div className="container-fluid">
            <div className="row gx-5">
              <div className="col-lg-2 col-md-3 mb-4 mb-md-0">
                <h4 className="mb-0 ct_fs_20 mb-4">Payment</h4>
                <div className="ct_filter_btn">
                  <button
                    className="ct_outline_grey ct_yellow_btn ct_h_35 d-flex align-items-center gap-2"

                  >
                    Filter <img src="/assets/img/octicon_filter-16.png" alt="" />
                  </button>
                </div>
                <div
                  className="ct_filter_sidebar ct_custom_scroll p-0 "
                >
                  <div
                    className="ct_close_filter d-block d-lg-none"

                  >
                    <i className="fa-solid fa-xmark"></i>
                  </div>
                  <div className="mt-4">
                    <h5 className="ct_fs_16 mb-3">User Type</h5>
                    <ul>
                      <li>
                        <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value=""
                            id="flexCheckDefault"
                          />
                          <label for="" className="ct_text_clr_757886">
                            All Users
                          </label>
                        </div>
                      </li>
                      <li className="mt-2">
                        <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value=""
                            id="flexCheckDefault"
                          />
                          <label for="" className="ct_text_clr_757886">
                            Freelancers
                          </label>
                        </div>
                      </li>
                      <li className="mt-2">
                        <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value=""
                            id="flexCheckDefault"
                          />
                          <label for="" className="ct_text_clr_757886">
                            Founders
                          </label>
                        </div>
                      </li>
                      <li className="mt-2">
                        <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value=""
                            id="flexCheckDefault"
                          />
                          <label for="" className="ct_text_clr_757886">
                            Founders
                          </label>
                        </div>
                      </li>
                      <li className="mt-2">
                        <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value=""
                            id="flexCheckDefault"
                          />
                          <label for="" className="ct_text_clr_757886">
                            Enterprise
                          </label>
                        </div>
                      </li>
                      <li className="mt-2">
                        <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value=""
                            id="flexCheckDefault"
                          />
                          <label for="" className="ct_text_clr_757886">
                            Investor
                          </label>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div className="mt-4">
                    <h5 className="ct_fs_16 mb-3">Plan Type</h5>
                    <ul>
                      <li>
                        <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value=""
                            id="flexCheckDefault"
                          />
                          <label for="" className="ct_text_clr_757886">
                            NuGlow
                          </label>
                        </div>
                      </li>
                      <li className="mt-2">
                        <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value=""
                            id="flexCheckDefault"
                          />
                          <label for="" className="ct_text_clr_757886">
                            NuForge
                          </label>
                        </div>
                      </li>
                      <li className="mt-2">
                        <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value=""
                            id="flexCheckDefault"
                          />
                          <label for="" className="ct_text_clr_757886">
                            NuStar
                          </label>
                        </div>
                      </li>
                      <li className="mt-2">
                        <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value=""
                            id="flexCheckDefault"
                          />
                          <label for="" className="ct_text_clr_757886">
                            Custom Enterprise Plan
                          </label>
                        </div>
                      </li>
                      <li className="mt-2">
                        <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value=""
                            id="flexCheckDefault"
                          />
                          <label for="" className="ct_text_clr_757886">
                            Coach Access
                          </label>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div className="mt-4">
                    <h5 className="ct_fs_16 mb-3">Status</h5>
                    <ul>
                      <li>
                        <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value=""
                            id="flexCheckDefault"
                          />
                          <label for="" className="ct_text_clr_757886">
                            Active
                          </label>
                        </div>
                      </li>
                      <li className="mt-2">
                        <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value=""
                            id="flexCheckDefault"
                          />
                          <label for="" className="ct_text_clr_757886">
                            In Trial (30 Days)
                          </label>
                        </div>
                      </li>
                      <li className="mt-2">
                        <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value=""
                            id="flexCheckDefault"
                          />
                          <label for="" className="ct_text_clr_757886">
                            Expired
                          </label>
                        </div>
                      </li>
                      <li className="mt-2">
                        <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value=""
                            id="flexCheckDefault"
                          />
                          <label for="" className="ct_text_clr_757886">
                            Canceled
                          </label>
                        </div>
                      </li>
                      <li className="mt-2">
                        <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value=""
                            id="flexCheckDefault"
                          />
                          <label for="" className="ct_text_clr_757886">
                            Refunded
                          </label>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div className="mt-4">
                    <h5 className="ct_fs_16 mb-3">Payment Type</h5>
                    <ul>
                      <li>
                        <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value=""
                            id="flexCheckDefault"
                          />
                          <label for="" className="ct_text_clr_757886">
                            Subscription
                          </label>
                        </div>
                      </li>
                      <li className="mt-2">
                        <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value=""
                            id="flexCheckDefault"
                          />
                          <label for="" className="ct_text_clr_757886">
                            eBook Sale
                          </label>
                        </div>
                      </li>
                      <li className="mt-2">
                        <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value=""
                            id="flexCheckDefault"
                          />
                          <label for="" className="ct_text_clr_757886">
                            Event Ticket
                          </label>
                        </div>
                      </li>
                      <li className="mt-2">
                        <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value=""
                            id="flexCheckDefault"
                          />
                          <label for="" className="ct_text_clr_757886">
                            Freelancer Payout
                          </label>
                        </div>
                      </li>
                      <li className="mt-2">
                        <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value=""
                            id="flexCheckDefault"
                          />
                          <label for="" className="ct_text_clr_757886">
                            Investor Transfer
                          </label>
                        </div>
                      </li>
                    </ul>
                  </div>

                </div>
              </div>
              <div className='col-lg-10 col-md-9 mb-4 mb-md-0'>
                <div className="d-flex align-items-center gap-3 justify-content-between mb-4 ct_flex_col_1199">
                  <div>
                    <h4 className="mb-0 ct_fs_20  mb-0">Payments & Subscriptions</h4>
                    <p className="mb-0 ct_text_clr_757886">
                      View and manage all user subscriptions, purchases, and payouts across Nuvio
                    </p>
                  </div>
                  <div className="d-flex align-items-center gap-3 ct_flex_col_575 ct_w_100_575">
                    <div className="position-relative ct_w_100_575">
                      <input
                        type="text"
                        className="form-control ct_input ct_h_40 ps-5 ct_border_radius_20"
                        placeholder="Search by Title"
                      />
                      <i className="fa-solid fa-search ct_input_icon_left"></i>
                    </div>
                    <button className='ct_yellow_btn ct_h_40 ct_white_nowrap ct_w_100_575'><i class="fa-solid fa-plus me-1 ct_fs_14"></i>Export CSV</button>

                  </div>
                </div>


                <div class="d-flex align-items-center gap-3 justify-content-between mb-3 ct_flex_col_575 ct_pb_3_575" style={{ borderBottom: "1px solid rgb(204, 204, 204)" }}>
                  <ul class="ct_table_filter border-0">
                    <li class="active">All Transactions (50)  </li>
                    <li>Subscriptions (30)</li>
                    <li>Digital Sales & Payouts (50)</li>
                    <li>Funding Activity</li>
                  </ul>

                </div>


                <div class="table-responsive ct_custom_table ct_custom_table2 pt-2">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>User</th>
                        <th>Role</th>
                        <th>Plan</th>
                        <th>Amount</th>
                        <th>Payment Date</th>
                        <th>Status</th>
                        <th>Next Billing</th>
                        <th></th>

                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <h5 class="ct_fs_16  mb-0">Alex Brown</h5>
                        </td>
                        <td>Freelancer</td>
                        <td>NuGlow</td>
                        <td>$100:00</td>
                        <td>Jun 29,2025</td>
                        <td>
                          <span class="ct_publish_badge">Active</span>
                        </td>
                        <td>
                          <div class="position-relative"><select class="form-control ct_input border-0 pe-5"><option value="">Jun 29,2025</option></select><i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i></div>
                        </td>
                        <td>
                          <div class="ct_right_dropdown dropdown">
                            <button
                              id="dropdownMenuButton"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <i class="fa-solid fa-ellipsis"></i>
                            </button>
                            <ul
                              class="dropdown-menu"
                              aria-labelledby="dropdownMenuButton1"
                            >
                              <li>
                                <a
                                  class="dropdown-item"
                                  onClick={() => navigate(adminPaths?.ReportDetails)}

                                >View Subscription</a>
                              </li>
                              <li>
                                <a
                                  class="dropdown-item ct_yellow_text"
                                  href="javascript:void(0)"

                                >Cancel / Pause Plan
                                </a>
                              </li>
                              <li>
                                <a
                                  class="dropdown-item ct_darksky_blue_text"

                                  href="javascript:void(0)"
                                >Upgrade/Downgrade</a>
                              </li>
                              <li>
                                <a
                                  class="dropdown-item "

                                  href="javascript:void(0)"
                                >Issue Refund</a>
                              </li>

                              <li>
                                <a
                                  class="dropdown-item ct_orange_text"
                                  href="javascript:void(0)"
                                  data-bs-target="#ct_suspend_account"
                                  data-bs-toggle="modal"
                                >Download Invoice
                                </a>
                              </li>

                            </ul>
                          </div>
                        </td>


                      </tr>
                      <tr>
                        <td>
                          <h5 class="ct_fs_16  mb-0">Alex Brown</h5>
                        </td>
                        <td>Freelancer</td>
                        <td>NuGlow</td>
                        <td>$100:00</td>
                        <td>Jun 29,2025</td>
                        <td>
                          <span class="ct_publish_badge">Active</span>
                        </td>
                        <td>
                          <div class="position-relative"><select class="form-control ct_input border-0 pe-5"><option value="">Jun 29,2025</option></select><i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i></div>
                        </td>
                        <td>
                          <div class="ct_right_dropdown dropdown">
                            <button
                              id="dropdownMenuButton"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <i class="fa-solid fa-ellipsis"></i>
                            </button>
                            <ul
                              class="dropdown-menu"
                              aria-labelledby="dropdownMenuButton1"
                            >
                              <li>
                                <a
                                  class="dropdown-item"
                                  onClick={() => navigate(adminPaths?.ReportDetails)}

                                >View Subscription</a>
                              </li>
                              <li>
                                <a
                                  class="dropdown-item ct_yellow_text"
                                  href="javascript:void(0)"

                                >Cancel / Pause Plan
                                </a>
                              </li>
                              <li>
                                <a
                                  class="dropdown-item ct_darksky_blue_text"

                                  href="javascript:void(0)"
                                >Upgrade/Downgrade</a>
                              </li>
                              <li>
                                <a
                                  class="dropdown-item "

                                  href="javascript:void(0)"
                                >Issue Refund</a>
                              </li>

                              <li>
                                <a
                                  class="dropdown-item ct_orange_text"
                                  href="javascript:void(0)"
                                  data-bs-target="#ct_suspend_account"
                                  data-bs-toggle="modal"
                                >Download Invoice
                                </a>
                              </li>

                            </ul>
                          </div>
                        </td>


                      </tr>
                      <tr>
                        <td>
                          <h5 class="ct_fs_16  mb-0">Alex Brown</h5>
                        </td>
                        <td>Freelancer</td>
                        <td>NuGlow</td>
                        <td>$100:00</td>
                        <td>Jun 29,2025</td>
                        <td>
                          <span class="ct_publish_badge">Active</span>
                        </td>
                        <td>
                          <div class="position-relative"><select class="form-control ct_input border-0 pe-5"><option value="">Jun 29,2025</option></select><i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i></div>
                        </td>
                        <td>
                          <div class="ct_right_dropdown dropdown">
                            <button
                              id="dropdownMenuButton"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <i class="fa-solid fa-ellipsis"></i>
                            </button>
                            <ul
                              class="dropdown-menu"
                              aria-labelledby="dropdownMenuButton1"
                            >
                              <li>
                                <a
                                  class="dropdown-item"
                                  onClick={() => navigate(adminPaths?.ReportDetails)}

                                >View Subscription</a>
                              </li>
                              <li>
                                <a
                                  class="dropdown-item ct_yellow_text"
                                  href="javascript:void(0)"

                                >Cancel / Pause Plan
                                </a>
                              </li>
                              <li>
                                <a
                                  class="dropdown-item ct_darksky_blue_text"

                                  href="javascript:void(0)"
                                >Upgrade/Downgrade</a>
                              </li>
                              <li>
                                <a
                                  class="dropdown-item "

                                  href="javascript:void(0)"
                                >Issue Refund</a>
                              </li>

                              <li>
                                <a
                                  class="dropdown-item ct_orange_text"
                                  href="javascript:void(0)"
                                  data-bs-target="#ct_suspend_account"
                                  data-bs-toggle="modal"
                                >Download Invoice
                                </a>
                              </li>

                            </ul>
                          </div>
                        </td>


                      </tr>
                      <tr>
                        <td>
                          <h5 class="ct_fs_16  mb-0">Alex Brown</h5>
                        </td>
                        <td>Freelancer</td>
                        <td>NuGlow</td>
                        <td>$100:00</td>
                        <td>Jun 29,2025</td>
                        <td>
                          <span class="ct_inactive_badge">Canceled</span>
                        </td>
                        <td>
                          <div class="position-relative"><select class="form-control ct_input border-0 pe-5"><option value="">Jun 29,2025</option></select><i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i></div>
                        </td>
                        <td>
                          <div class="ct_right_dropdown dropdown">
                            <button
                              id="dropdownMenuButton"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <i class="fa-solid fa-ellipsis"></i>
                            </button>
                            <ul
                              class="dropdown-menu"
                              aria-labelledby="dropdownMenuButton1"
                            >
                              <li>
                                <a
                                  class="dropdown-item"
                                  onClick={() => navigate(adminPaths?.ReportDetails)}

                                >View Subscription</a>
                              </li>
                              <li>
                                <a
                                  class="dropdown-item ct_yellow_text"
                                  href="javascript:void(0)"

                                >Cancel / Pause Plan
                                </a>
                              </li>
                              <li>
                                <a
                                  class="dropdown-item ct_darksky_blue_text"

                                  href="javascript:void(0)"
                                >Upgrade/Downgrade</a>
                              </li>
                              <li>
                                <a
                                  class="dropdown-item "

                                  href="javascript:void(0)"
                                >Issue Refund</a>
                              </li>

                              <li>
                                <a
                                  class="dropdown-item ct_orange_text"
                                  href="javascript:void(0)"
                                  data-bs-target="#ct_suspend_account"
                                  data-bs-toggle="modal"
                                >Download Invoice
                                </a>
                              </li>

                            </ul>
                          </div>
                        </td>


                      </tr>
                      <tr>
                        <td>
                          <h5 class="ct_fs_16  mb-0">Alex Brown</h5>
                        </td>
                        <td>Freelancer</td>
                        <td>NuGlow</td>
                        <td>$100:00</td>
                        <td>Jun 29,2025</td>
                        <td>
                          <span class="ct_suspended">Trial (Day 12)</span>
                        </td>
                        <td>
                          <div class="position-relative"><select class="form-control ct_input border-0 pe-5"><option value="">Jun 29,2025</option></select><i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i></div>
                        </td>
                        <td>
                          <div class="ct_right_dropdown dropdown">
                            <button
                              id="dropdownMenuButton"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <i class="fa-solid fa-ellipsis"></i>
                            </button>
                            <ul
                              class="dropdown-menu"
                              aria-labelledby="dropdownMenuButton1"
                            >
                              <li>
                                <a
                                  class="dropdown-item"
                                  onClick={() => navigate(adminPaths?.ReportDetails)}

                                >View Subscription</a>
                              </li>
                              <li>
                                <a
                                  class="dropdown-item ct_yellow_text"
                                  href="javascript:void(0)"

                                >Cancel / Pause Plan
                                </a>
                              </li>
                              <li>
                                <a
                                  class="dropdown-item ct_darksky_blue_text"

                                  href="javascript:void(0)"
                                >Upgrade/Downgrade</a>
                              </li>
                              <li>
                                <a
                                  class="dropdown-item "

                                  href="javascript:void(0)"
                                >Issue Refund</a>
                              </li>

                              <li>
                                <a
                                  class="dropdown-item ct_orange_text"
                                  href="javascript:void(0)"
                                  data-bs-target="#ct_suspend_account"
                                  data-bs-toggle="modal"
                                >Download Invoice
                                </a>
                              </li>

                            </ul>
                          </div>
                        </td>


                      </tr>


                    </tbody>
                  </table>
                </div>

              </div>
            </div>
          </div>
        </div>
      </AdminLayout>
    </div>
  )
}

export default Payment